// import { DynamicHostComponent } from '../dynamic-host/dynamic-host.component';
import { ModalModel } from './modal.model';

export class DynamicHostModel {
    modalModel?: ModalModel;
    instantiated: boolean;
}
